// LoginLabel.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './LoginLabel.css';

/**
 * LoginLabel Component
 * 
 * This component renders a label for login form fields.
 * 
 * @param {string} text - The text of the label.
 * 
 * @returns {ReactNode} The rendered component.
 */
const LoginLabel = ({ text, align = "left" }) => {

  // ----- CONTEXT ----- //

  // Theme Context
  const { theme } = useTheme();

  // ----- RENDER ----- //

  return (

    <div
      className="login-label-container"
      style={{
        color: theme.foreground,
        textAlign: align || "left",
        marginLeft: align === "left" ? "6px" : "0px",
      }}>
      {text}
    </div>

  );
};

export default LoginLabel;
